import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const GEOAPIFY_AUTOCOMPLETE_URL = "https://api.geoapify.com/v1/geocode/autocomplete";
const GEOAPIFY_PLACE_DETAILS_URL = "https://api.geoapify.com/v2/place-details";
const GEOAPIFY_API_KEY = '6313651e13634833bf8bd0c8dbdfde7d'; // Replace with your key if needed

export function useGeoapifySearch(query, debounceMs = 300) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const sessionTokenRef = useRef(uuidv4());

  useEffect(() => {
    if (!query) {
      setSuggestions([]);
      sessionTokenRef.current = uuidv4();
      return;
    }

    const controller = new AbortController();

    const timeout = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await axios.get(GEOAPIFY_AUTOCOMPLETE_URL, {
          signal: controller.signal,
          params: {
            text: query,
            apiKey: GEOAPIFY_API_KEY,
            lang: "en",
            filter: "countrycode:gb,ie",
            limit: 5,
            session: sessionTokenRef.current,
          },
        });

        setSuggestions(res.data.features || []);
      } catch (err) {
        if (err.name !== "CanceledError" && err.name !== "AbortError") {
          console.error("Geoapify suggest error:", err);
        }
      } finally {
        setLoading(false);
      }
    }, debounceMs);

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [query, debounceMs]);

  const retrievePlace = async (placeId) => {
    try {
      const res = await axios.get(GEOAPIFY_PLACE_DETAILS_URL, {
        params: {
          id: placeId,
          apiKey: GEOAPIFY_API_KEY,
        },
      });
      return res.data.features?.[0] || null;
    } catch (err) {
      console.error("Geoapify retrieve error:", err);
      return null;
    }
  };

  return { suggestions, loading, retrievePlace };
}